/**
 * @description fetches the options for the eligibility dropdown used by the filter form
 */

import { useQuery } from '@tanstack/react-query';

import processOrderedDropdownOptions from '../utils/processOrderedDropdownOptions';
import fetchDropdownOptions from '../utils/fetchDropdownOptions';

const fetchEligibilities = fetchDropdownOptions(
  'personnel.clearance.type',
  'clearance eligibility'
);

const useEligibilityOptions = () => {
  const { data, isError, isLoading } = useQuery({
    queryKey: ['useEligibilityOptions'],
    queryFn: fetchEligibilities,
    select: processOrderedDropdownOptions,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });

  return {
    data,
    isError,
    isLoading
  };
};

export default useEligibilityOptions;
